{
  "bliksy": {
    "inputPlaceholder": "Frag mich was",
    "disclaimer": "BLIKSY ist KI-gestützt und kann Fehler enthalten. Bitte überprüfe die Antworten.",
    "resizeHandle": "Chat-Bereich anpassen"
  },
  "voiceInput": {
    "startRecording": "Sprachaufnahme starten",
    "stopRecording": "Aufnahme beenden",
    "cancelRecording": "Aufnahme abbrechen",
    "transcribing": "Wird transkribiert...",
    "microphoneDenied": "Zugriff auf das Mikrofon wurde verweigert.",
    "recordingFailed": "Aufnahme fehlgeschlagen. Bitte versuche es erneut.",
    "transcriptionFailed": "Audio konnte nicht transkribiert werden. Bitte versuche es erneut."
  },
  "chat": {
    "sendMessage": "Nachricht senden",
    "transcript": "Chat-Verlauf",
    "messageFailed": "Diese Nachricht kann nicht angezeigt werden.",
    "retry": "Erneut versuchen",
    "sourcesLabel": "Quellen",
    "chart": {
      "loading": "Diagramm wird vorbereitet…",
      "failed": "Diagramm konnte nicht erstellt werden.",
      "hoursSuffix": "{{value}}h",
      "percentSuffix": "{{value}}%",
      "coverageOmitted": "{{omitted}} von {{requested}} Einträgen werden nicht angezeigt.",
      "coverageTruncated": "Es werden nur die größten {{rendered}} Einträge angezeigt.",
      "pointLabels": {
        "restricted": "Kein Zugriff",
        "unknown": "Unbekannt",
        "unassigned": "Nicht zugeordnet"
      }
    },
    "diagram": {
      "label": "Diagramm",
      "loading": "Diagramm wird vorbereitet…",
      "failed": "Das Diagramm konnte nicht dargestellt werden.",
      "expand": "Diagramm vergrößern",
      "zoomIn": "Vergrößern",
      "zoomOut": "Verkleinern",
      "resetZoom": "Ansicht zurücksetzen"
    },
    "document": {
      "preparing": "Datei wird vorbereitet…",
      "failed": "Die Datei konnte nicht erstellt werden.",
      "download": "Datei herunterladen",
      "rows": "{{rows}} Zeilen · verfügbar bis {{expiry}}",
      "partialRows": "Erste {{rows}} Zeilen · verfügbar bis {{expiry}}",
      "rowsOnly": "{{rows}} Zeilen",
      "partialRowsOnly": "Erste {{rows}} Zeilen",
      "omitted": "{{omitted}} Zeilen sind nicht enthalten.",
      "expired": "Diese Datei ist nicht mehr verfügbar.",
      "downloadFailed": "Der Download konnte nicht gestartet werden."
    },
    "entityView": {
      "loading": "Ansicht wird vorbereitet…",
      "unavailable": "Diese Ansicht ist nicht mehr verfügbar.",
      "noDecisionRules": "Dieser Schritt hat keine Entscheidungstabelle mehr.",
      "loadFailed": "Die Ansicht konnte nicht geladen werden.",
      "current": "Aktueller Stand",
      "updatedAt": "Aktualisiert am {{date}}",
      "untitledStep": "Unbenannter Schritt",
      "openProcess": "Prozess öffnen",
      "openFullscreen": "Vollbild öffnen",
      "exitFullscreen": "Vollbild beenden"
    },
    "entityCard": {
      "loading": "Details werden geladen…",
      "unavailable": "Dieser Eintrag ist nicht mehr verfügbar.",
      "loadFailed": "Die Details konnten nicht geladen werden."
    },
    "attachment": {
      "fallbackName": "Datei",
      "label": "Angehängte Datei",
      "attach": "Datei anhängen",
      "remove": "Anhang entfernen",
      "dropHint": "PDF oder Bild hier ablegen",
      "uploading": "Wird hochgeladen...",
      "tooMany": "Höchstens {{max}} Dateien pro Nachricht",
      "unsupported": "Nur PDF-, PNG- oder JPEG-Dateien",
      "tooLarge": "Höchstens {{maxMegabytes}} MB",
      "uploadFailed": "Upload fehlgeschlagen"
    },
    "feedback": {
      "thumbsUp": "Hilfreich",
      "thumbsDown": "Nicht hilfreich",
      "commentTitle": "Was war an dieser Antwort falsch?",
      "commentPlaceholder": "Sag uns, was nicht gepasst hat",
      "commentSend": "Senden",
      "error": "Das Feedback konnte nicht gespeichert werden."
    }
  },
  "thinkingPhases": {
    "stepSummary": {
      "start1": "Aufnahme wird ausgewertet…",
      "middle1": "Schritt wird zusammengefasst…",
      "end1": "Formulierung wird verfeinert…"
    },
    "chat": {
      "start1": "Lese deine Frage…",
      "start2": "Verstehe deine Frage…",
      "middle1": "Suche relevante Informationen…",
      "middle2": "Prüfe verschiedene Quellen…",
      "middle3": "Analysiere Prozessmodell…",
      "end1": "Formuliere Antwort…",
      "end2": "Feile am Wortlaut…"
    }
  }
}
